<template>
    <div>
        <Wp_nav_bar title="商务合作"></Wp_nav_bar>
        <div style=" border-radius: 5px; box-shadow: 0px 1px 3px #aaaaaa; margin: 16px">
            <Wp_image url="https://cdn.quasar.dev/img/mountains.jpg" radius="5px 5px 0px 0px"></Wp_image>
            <div style="padding: 16px">
                <div style="font-size: 20px">商务合作</div>

                <div style="padding-top: 16px">
                    <span v-html="content" style="white-space: pre-wrap; font-size: 14px"/>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    import Wp_nav_bar from "../custom/Wp_nav_bar";
    import Wp_image from "../custom/Wp_image";

    export default {
        name: "Business",
        components: {Wp_image, Wp_nav_bar},
        data() {
            return {
                content:
                    "<span style='font-size: 24px'>华经理</span>\n微信号: xiaohuayes\nQQ号: 1919112418\n\n\n<span style='font-size: 24px'>单经理</span>\n微信号: Sjj1314N\nQQ号: 609488834",
            };
        },
    };
</script>

<style scoped>
</style>